import React from 'react'
import style from './Header.css'

export const Header = ({title, glyphicon}) => {
    return (
        <div className={`page-header row ${style.Header_calendarMantainer}`}>
            <div className="col-md-9">
                <h3><span className={glyphicon}></span> {title}
                </h3>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./frontEnd/admin/CalendarMaintainer/components/Header.jsx